<template>
  <div class="app-container">
    <div>
      <div style="padding: 10px">
        <el-button type="primary" style="margin-left: 4px" @click="newAdd" :disabled="!canWrite">新增</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="openPage" :disabled="!canWrite">派工</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="onMaterial" :disabled="!canWrite">派工用料</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="viewType != 'create'" v-if="canWrite">保存</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="save" :disabled="(Status == 1 && viewType != 'edit') || Status == 2" v-if="canWrite">变更</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="onCopy" :disabled="!canWrite">复制</el-button>
        <el-button type="primary" style="margin-left: 4px" @click="handleDelete" :disabled="!isSave || !canWrite">删除</el-button>
        <el-button type="primary" style="margin-left: 4px" :disabled="!isSave" @click="onPrint(row)">打印</el-button>
        <el-button type="primary" @click="openSetField">明细字段</el-button>
      </div>
      <el-form :model="data" ref="form" :inline="true" :line-form="true" label-width="80px" status-icon>
        <el-row style="margin-top: 18px">
          <el-form-item label="派工日期:" required label-width="120px">
            <!-- <span class="not-edit" v-if="Status === 2">{{ data.DocDate }}</span> -->
            <el-date-picker v-model="data.DocDate" type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期" style="width: 180px" @change="v => changeDada(v)"> </el-date-picker>
          </el-form-item>
          <el-form-item label="单据编码:" required label-width="120px">
            <!-- <span style="display: inline-block; width: 180px" v-if="Mode == 0" class="detail-span">{{ data.DocNo }}</span> -->
            <el-input style="width: 180px" v-model="data.DocNo" placeholder="请输入单据编码"></el-input>
          </el-form-item>
          <el-form-item label="派工类型:" required label-width="120px">
            <el-select v-model="data.InType" @change="handleInTypeChange">
              <el-option label="按产品派工" :value="1" key="a1"></el-option>
              <el-option label="按工单派工" :value="2" key="a2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="加工阶段:" required label-width="120px">
            <!-- <span class="not-edit" v-if="Status === 2">{{ data.ProcessStages }}</span> -->
            <el-select v-model="data.ProcessStages" multiple clearable>
              <el-option v-for="item in machiningStageList" :key="item.MachiningStageId" :value="item.MachiningStageId" :label="item.Name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="生产类型:" required label-width="110px">
            <el-select v-model="data.ProductionType" @change="handleProductionTypeChange">
              <el-option :value="0" label="自制"></el-option>
              <el-option :value="1" label="委外"></el-option>
            </el-select>
          </el-form-item>
          <!-- <el-form-item label="生产人数:">
            <el-input v-model="data.Quantity" placeholder="请输入生产人数" clearable />
          </el-form-item> -->
          <el-form-item label="派工人:" label-width="120px">
            <span class="span" style="width: 180px !important">{{ data.EmpName }}</span>
          </el-form-item>
          <el-form-item label="制单时间:" label-width="120px">
            <span>{{ $commonJs.toDateString(data.ReviewTime) }}</span>
          </el-form-item>
          <el-form-item label="变更时间:" label-width="120px">
            <span>{{ $commonJs.toDateString(data.UpdateTime) }}</span>
          </el-form-item>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="备注:" label-width="120px">
              <el-input type="textarea" v-model="data.Remark" :autosize="{ minRows: 2, maxRows: 4 }" maxlength="60" placeholder="请填写备注信息" style="width: 600px" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-table
        key="table1"
        border
        class="table_bottom table-line tb-c-head"
        :row-class-name="tableRowClassName"
        :data="tableData.filter(item => item.T != 2)"
        stripe
        style="margin-top: 18px"
        v-if="showDetail"
        ref="table1"
        show-summary
        :summary-method="getSummaries"
      >
        <!-- <el-table-column width="50" prop="Sn" align="left" label="序号" v-if="showField('序号')" /> -->
        <el-table-column min-width="110" align="left" label="车间/加工商" v-if="showField('车间/加工商')">
          <template slot-scope="{ row }">
            <span>{{ data.ProductionType == 1 ? row.TradeUnitName : row.DpName }}</span>
          </template>
        </el-table-column>
        <el-table-column width="110" prop="ProcessUnitName" label="加工单元" v-if="showField('加工单元')" />
        <el-table-column min-width="100" prop="ProcessStageName" label="加工阶段" sortable v-if="showField('加工阶段')" />
        <el-table-column width="100" prop="ProductNo" label="产品编码" v-if="showField('产品编码')" />
        <el-table-column min-width="150" prop="ProductName" label="产品名称" v-if="showField('产品名称')" />
        <el-table-column min-width="140" prop="ProductSpec" label="产品规格" v-if="showField('产品规格')" />
        <el-table-column width="60" prop="UnitName" align="left" label="主单位" v-if="showField('主单位')" />
        <el-table-column width="100" prop="BatchNumber" align="left" label="批号" v-if="showField('批号')" />
        <el-table-column width="90" prop="Quantity" label="主数量" align="right" v-if="showField('主数量')" />
        <el-table-column width="60" prop="UnitName2" label="辅单位" v-if="showField('辅单位')" />
        <el-table-column width="90" prop="Quantity2" label="辅数量" align="right" v-if="showField('辅数量')" />
        <el-table-column width="80" prop="DispatchQuantity" label="派工数" align="right" v-if="showField('派工数')">
          <template slot-scope="{ row }">
            <el-input v-model="row.DispatchQuantity" @change="editT(row)" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column width="80" prop="PdNum" label="生产人数" align="right" v-if="showField('生产人数')">
          <template slot-scope="{ row }">
            <el-input v-model="row.PdNum" @change="editT(row)" style="width: 100%" />
          </template>
        </el-table-column>
        <el-table-column width="90" prop="InQuantity" align="right" label="累计报工数" v-if="showField('累计报工数')" />
        <el-table-column min-width="100" prop="WarehouseName" label="预入仓" v-if="showField('预入仓')" />
        <el-table-column width="60" prop="ExistQuantity" align="right" label="现存量" v-if="showField('现存量')" />
        <el-table-column width="70" prop="IsNetWeight" label="是否去皮" v-if="showField('是否去皮')">
          <template slot-scope="{ row }">
            <span>{{ row.IsNetWeight ? '是' : '否' }}</span>
          </template>
        </el-table-column>
        <el-table-column min-width="160" label="备注" v-if="showField('备注')">
          <template slot-scope="{ row }">
            <el-input v-model="row.Remark" @change="editT(row)" placeholder="请输入备注" />
          </template>
        </el-table-column>
        <el-table-column label="操作" width="80" fixed="right">
          <template slot-scope="{ row, $index }">
            <el-button type="text" size="mini" @click="onRowDelete(row, $index)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <div class="mtx10">
        <div class="flex space-between">
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核人</div>
            <div class="center el-form-item__label">{{ data.ReviewEmpName }}</div>
          </div>
          <div class="flex flex1">
            <div class="mrx18 center el-form-item__label">审核时间</div>
            <div class="center el-form-item__label">{{ data.ReviewTime }}</div>
          </div>
        </div>
      </div> -->
    </div>
    <edit-dialog
      ref="editDialog"
      @saved="saved"
      :ProcessStages="data.ProcessStages"
      :DocDate="data.DocDate"
      :ProductionType="data.ProductionType"
      :InType="data.InType"
      :processList="machiningStageList"
    ></edit-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />
    <field-dialog ref="fieldDialog" @close-saved="setTbField" />
  </div>
</template>
<script>
import editDialog from './editDialog'
import accountSelect from '@/components/business/stock/select'
import mouldSelect from '@/components/production/clothmanagement/cloth/select'

import empDialog from '@/components/personnel/result/record/listDialog'
import optionMixins from '@/mixins/option'
import fieldDialog from '@/components/common/fieldDialog'

export default {
  name: 'editdispatch',
  mixins: [optionMixins],
  components: {
    editDialog,
    accountSelect,
    mouldSelect,
    empDialog,
    fieldDialog
  },
  data() {
    return {
      api: require('@/api/pr/PrDispatchDoc').default,
      pdApi: require('@/api/ba/product').default,
      code_api: require('@/api/sy/serialCode').default,
      commonApi: require('@/api/common/common').default,
      docSetting_api: require('@/api/sy/docSetting').default,
      machiningStageApi: require('@/api/ba/machiningStage').default,
      sourceTypeApi: require('@/api/ba/sourceType').default,
      Mode: 0,
      pageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      mpageParams: {
        pageSize: 7, //分页大小
        pageIndex: 1
      },
      viewType: 'create',
      Status: 1,
      data: {
        DocId: 0,
        DocDate: this.$commonJs.getToday(),
        InType: 1, //派工类型
        ProcessStages: [], //加工阶段
        ProcessStage: '', //加工阶段
        ProductionType: 0, //生产类型
        Quantity: 0, //生产人数
        WorkShopId: 0, //车间
        TradeUnitId: '', //加工商
        EmpName: '', //制单人员
        EmpId: 0, //制单人员
        DocType: 0
      },
      isSave: false,
      tableData: [],
      machiningStageList: [],
      detailFields: [],
      showDetail: false,
      originalDocDate: this.$commonJs.getToday() // 原始日期
    }
  },
  created() {
    this.init()
  },
  computed: {
    canPrice() {
      return this.$permission.canPrice('/business/stock/productionshipping')
    },
    canWrite() {
      return this.$permission.canWrite('/business/stock/productionshipping')
    },
    canReview() {
      return this.$permission.canReview('/business/stock/productionshipping')
    }
  },
  mounted() {
    this.viewType = this.$route.params.type
    if (this.$route.params.type === 'create') {
      this.getPreviewNo()
      const user = this.$store.state.user
      if (user) {
        this.data.EmpName = user.name
        this.data.EmpId = user.empId
      }
      this.data.ReviewTime = this.$commonJs.getToday()
    } else if (this.$route.params.type === 'edit') {
      this.editInit(this.$route.params.data)
    }
  },
  methods: {
    openSetField() {
      this.$refs.fieldDialog.open().then(that => {
        that.getData({
          DocType: '派工单',
          Url: 'production/ticketmanagement/dispatch/edit'
        })
      })
    },
    setTbField() {
      this.showDetail = false
      this.docSetting_api.list({ DocType: '派工单', IsShow: true }).then(res => {
        if (res.Code == 0) {
          this.detailFields = res.Data.map(x => x.FormKey)
          this.$nextTick(() => {
            this.showDetail = true
          })
        }
      })
    },
    showField(type) {
      return this.detailFields.indexOf(type) != -1
    },
    setEmp(data) {
      console.log(data)
      this.data.EmpId = data.EmpId
      this.data.EmpName = data.EmpName
    },
    openEmp() {
      this.$refs.empDialog.open().then(that => {
        that.getData()
      })
    },
    getPreviewNo(dateTime = '') {
      this.code_api.previewNo('派工单', dateTime).then(res => {
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.$set(this.data, 'DocNo', res.Data.PreviewNo)
          this.originalDocDate = dateTime
        } else {
          this.$message.warning('获取派工单编号失败')
        }
      })
    },
    changeDada(dateTime = '') {
      if (this.tableData.length > 0) {
        this.$confirm('切换派工日期将清空表格数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            for (let i = this.tableData.length - 1; i >= 0; i--) {
              const row = this.tableData[i]
              if (row.T === null || row.T === 1) {
                row.T = 2
              } else if (row.T === 0) {
                this.tableData.splice(i, 1)
              }
            }
            this.code_api.previewNo('派工单', dateTime).then(res => {
              if (res.Code == 0) {
                this.Mode = res.Data.Mode
                this.$set(this.data, 'DocNo', res.Data.PreviewNo)
                this.originalDocDate = dateTime
              } else {
                this.$message.warning('获取派工单编号失败')
              }
            })
          })
          .catch(() => {
            console.log('this.originalDocDate', this.originalDocDate)
            this.$nextTick(() => {
              this.$set(this.data, 'DocDate', this.originalDocDate)
            })
          })
      }
    },
    editInit(data) {
      this.data = { ...data }
      this.originalDocDate = this.data.DocDate
      this.viewType = 'edit'
      this.isSave = true
      this.Status = data.Status

      this.tableData = data.Products.map(x => {
        return {
          ...x,
          T: null
        }
      })
    },
    init() {
      this.machiningStageApi.list({ Status: 1,Universal:true }).then(res => {
        if (res.Code === 0) {
          this.machiningStageList = res.Data
        }
      })
      this.sourceTypeApi.info('派工单').then(res => {
        this.data.DocType = res.SourceTypeId
      })
      this.callOptionApi()
      this.setTbField()
    },
    setAmount(p, q) {
      return Number((p * q).toFixed(5))
    },
    editT(row) {
      if (row.T !== 0) {
        row.T = 1
      }
    },

    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      const fieldNames = columns.map(col => col.property)
      fieldNames.forEach((field, index) => {
        if (field && ['Quantity', 'Quantity2', 'DispatchQuantity', 'InQuantity', 'PdNum'].includes(field)) {
          const values = data.map(item => Number(item[field]))
          if (!values.every(value => isNaN(value))) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr)
              if (!isNaN(value)) {
                return prev + value
              } else {
                return prev
              }
            }, 0)
            sums[index] = sums[index].toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })
          } else {
            sums[index] = '/'
          }
        } else {
          sums[index] = ''
        }
      })
      sums[0] = '合计'
      return sums
    },
    tableRowClassName({ row, rowIndex }) {
      row.index = rowIndex
    },
    async openPage() {
      if (!this.data.ProcessStages) {
        this.$message.warning('请先选择加工阶段')
        return
      }
      if (!this.data.InType) {
        this.$message.warning('请先选择派工类型')
        return
      }
      if (this.data.ProductionType === '') {
        this.$message.warning('请先选择生产类型')
        return
      }
      if (this.data.DocDate === '') {
        this.$message.warning('请先选择单据日期')
        return
      }

      let that = await this.$refs.editDialog.open()

      that.get_data({ ProcessStages: this.data.ProcessStages, ProductionType: this.data.ProductionType, DocDate: this.data.DocDate, InType: this.data.InType })
    },
    async saved({ subList }) {
      console.log('sublist', subList)
      let newItems = null
      // 按产品派工 1 就根据产品id过滤 || 按工单派工 2
      if(this.data.InType === 1) {
        newItems = subList.filter(newItem => {
          return !this.tableData.some(existingItem => existingItem.ProductId === newItem.ProductId)
        })
      }else{
        newItems = subList.filter(newItem => {
          return !this.tableData.some(existingItem => existingItem.WorkDocNo === newItem.WorkDocNo)
        })
      }

      const res = await this.sourceTypeApi.info('派工单')
      let SourceType = res.SourceTypeId
      const itemsWithT = newItems.map(item => ({
        ...item,
        T: 0,
        DispatchQuantity: null,
        PdNum: null,
        SourceId: item.WorkDocId,
        SourceNo: item.WorkDocNo,
        SourceDtsId: item.WorkDocMaterialId,
        ProcessStageName: item.ProcessStageName ?? null,
        SourceType: SourceType
      }))
      this.tableData.push(...itemsWithT)
      
      const indexMap = new Map(this.data.ProcessStages.map((value, index) => [value, index]))
      let sortedArr = new Array(this.data.ProcessStages.length)
      this.tableData.forEach(item => {
        const newIndex = indexMap.get(item.ProcessStage)
        if (newIndex !== undefined) {
          if (!sortedArr[newIndex]) {
            sortedArr[newIndex] = item
          } else {
            sortedArr[newIndex] = [sortedArr[newIndex], item].flat()
          }
        } else {
          sortedArr.push(item)
        }
      })

      this.tableData = sortedArr.flat()
    },
    // 新增
    newAdd() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        Object.assign(this.$data, this.$options.data.call(this))
        this.getPreviewNo()
        this.$route.params.type = 'create'
        this.viewType = 'create'
        this.init()
        this.isSave = false
      }
    },
    // 复制
    onCopy() {
      if (!this.isSave) {
        this.$message({ type: 'warning', message: '请先进行保存再操作' })
        return
      } else {
        this.api.copy(this.data.DocId).then(res => {
          if (res.Code === 0) {
            this.data = res.Data
            this.tableData = res.Data.Products.map(x => {
              return {
                ...x,
                T: 0
              }
            })
            this.Status = 1
            this.$route.params.type = 'create'
            this.viewType = 'create'
            this.originalDocDate = this.data.DocDate
            this.$route.params.data = res.Data
            this.isSave = false
            
          }else{
            this.$message({ type: 'warning', message: res.Msg })
          }
        })

      }
    },
    // 父表-删除
    handleDelete() {
      let id = this.data.DocId
      this.$confirm('确定删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.delete({ id }).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            this.newAdd()
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    onPrint(row) {
      var url = location.origin + '/#/customprintview/派工单/' + this.data.DocId
      window.open(url, '_blank')
    },
    //派工用料
    onMaterial() {
      let id = this.data.DocId
      this.$confirm('是否生成领料任务?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
        this.api.generateTask({ id }).then(res => {
          if (res.Code === 0) {
            this.$message({ type: 'success', message: res.Msg })
            // this.$emit('deleted')
          } else {
            this.$message({ type: 'warning', message: res.Msg })
          }
        })
      })
    },
    //切换生产类型
    handleProductionTypeChange(newValue) {
      if (this.tableData.length > 0) {
        this.$confirm('切换生产类型将清空表格数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            for (let i = this.tableData.length - 1; i >= 0; i--) {
              const row = this.tableData[i]
              if (row.T === null || row.T === 1) {
                row.T = 2
              } else if (row.T === 0) {
                this.tableData.splice(i, 1)
              }
            }
          })
          .catch(() => {
            this.$nextTick(() => {
              this.data.ProductionType = newValue === 0 ? 1 : 0
            })
          })
      }
    },
    //切换派工类型
    handleInTypeChange(newValue) {
      if (this.tableData.length > 0) {
        this.$confirm('切换派工类型将清空表格数据，是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            for (let i = this.tableData.length - 1; i >= 0; i--) {
              const row = this.tableData[i]
              if (row.T === null || row.T === 1) {
                row.T = 2
              } else if (row.T === 0) {
                this.tableData.splice(i, 1)
              }
            }
          })
          .catch(() => {
            this.$nextTick(() => {
              this.data.InType = newValue === 1 ? 2 : 1
            })
          })
      }
    },
    // 子表-删除
    onRowDelete(row, index) {
      if (row.T == null || row.T == 1) {
        row.T = 2
      } else if (row.T == 0) {
        this.tableData.splice(index, 1)
      }
    },
    reView1() {
      let id = this.data.DocId
      this.api.examine1(id).then(res => {
        if (res.Code === 0) {
          this.$message({ type: 'success', message: res.Msg })
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message({ type: 'warning', message: res.Msg })
        }
      })
    },
    save() {
      //验证表单是否填写
      let yanzheng = ['DocDate', 'DocNo', 'InType', 'ProcessStages']
      for (let key in this.data) {
        if (yanzheng.indexOf(key) !== -1 && !this.data[key]) {
          this.$message({ type: 'warning', message: '表单未填写完整' })
          return
        }
      }
      if (!this.tableData.length) {
        this.$message({ type: 'warning', message: '请添加产品' })
        return
      }

      // 检查派工数是否为空或0或中文或负数
      for (let item of this.tableData) {
        const quantity = item.DispatchQuantity
        if (!quantity || quantity === 0) {
          this.$message({ type: 'warning', message: '派工数不能为空或0' })
          return
        }
        if (isNaN(quantity)) {
          this.$message({ type: 'warning', message: '派工数必须为数字' })
          return
        }
        if (quantity < 0) {
          this.$message({ type: 'warning', message: '派工数不能为负数' })
          return
        }
      }
      // 检查生产人数是否为空或0或中文或负数
      for (let item of this.tableData) {
        const quantity = item.PdNum
        if (!quantity || quantity === 0) {
          this.$message({ type: 'warning', message: '派工数不能为空或0' })
          return
        }
        if (isNaN(quantity)) {
          this.$message({ type: 'warning', message: '派工数必须为数字' })
          return
        }
        if (quantity < 0) {
          this.$message({ type: 'warning', message: '派工数不能为负数' })
          return
        }
      }

      const Products = this.tableData
        .filter(item => item.T != null)
        .map(item => {
          return item
        })
      if (this.data.ProcessStages != null && this.data.ProcessStages.length > 0) {
        this.data.ProcessStage = this.data.ProcessStages.join(',')
      }
      let o = {
        ...this.data,
        Products
      }
      console.log('o', o)

      this.api.save(o).then(res => {
        if (res.Code === 0) {
          this.$message.success(res.Msg)
          this.isSave = true
          this.data.DocId = res.Data
          this.api.info(this.data.DocId).then(res => {
            if (res.Code === 0) {
              this.$route.params.data = res.Data
              this.editInit(res.Data)
            }
          })
        } else {
          this.$message.warning(res.Msg)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.dropdown-item {
  padding: 6px;
}

.mtx10 {
  padding: 10px;
}

.flex {
  display: flex;

  .text {
    width: 60px;
  }
}

.space-between {
  justify-content: space-between;
}

.center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex1 {
  flex: 1;
}

.mrx18 {
  margin-right: 18px;
}

.span {
  display: inline-block;
  width: 180px;
}

.w180 {
  width: 180px;
}
</style>
